import { useQuery } from "@tanstack/react-query";

import { useAuthenticated } from "../auth/SessionProvider";
import { post } from "./client";
import type { CatalogResponse } from "./types";

export function useCatalog() {
  const { token } = useAuthenticated();
  return useQuery({
    queryKey: ["catalog", token],
    queryFn: () => post<CatalogResponse>("/catalog", {}, token),
    staleTime: 60_000
  });
}
